export default "__VITE_ASSET__BiuRXzno__"